import {cdnImage} from '@/util/cdnImage';
import MUIContainer from '@/components/MUI-Components/MUI-Container';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, {memo} from 'react';
import DisplayImage from '@/components/Ui-components/display-image';
const checkIcon = cdnImage('white-label-exchange-development-new/solution-check-icon.svg');
import parse from 'html-react-parser';
import {colors, fontWeight} from '@/styles/tokens';

// ─── sx constants ─────────────────────────────────────────────────────────────

const cardSx = {
    bgcolor: colors.background.default,
    boxShadow: '0px 0px 12px 2px rgba(0,0,0,0.11)',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
} as const;

// ─── Component ────────────────────────────────────────────────────────────────

const SolutionModel = (props: any) => {
    const {heading, subheading, contentData} = props;

    return (
        <Box sx={{bgcolor: colors.background.subtle}} className="top-space bottom-spacing mobile-top-padding mobile-bottom-padding">
            <MUIContainer>
                <Box textAlign="center" maxWidth={1024} margin="0 auto" mb={6}>
                    <Typography variant="h2" component="h2" mb={3} fontSize={{xs: 32, sm: 52}} fontWeight={800} className="font-headers">
                        {heading}
                    </Typography>
                    <Typography variant="subtitle1" component="p" className="font-regular-text">
                        {subheading}
                    </Typography>
                </Box>

                <Grid container spacing={3} alignItems="stretch">
                    {contentData?.map((item: any, index: number) => (
                        <Grid item xs={12} sm={6} md={4} key={index} sx={{display: 'flex'}}>
                            <Box sx={cardSx}>
                                {/* White content area: title + bullets */}
                                <Box sx={{px: 3, pt: 3, pb: 2.5, bgcolor: '#fff'}}>
                                    <Typography
                                        className="font-headers"
                                        component="h3"
                                        sx={{
                                            fontWeight: fontWeight.bold,
                                            fontSize: 22,
                                            lineHeight: '31px',
                                            color: '#000',
                                            textAlign: 'center',
                                            mb: 3
                                        }}
                                    >
                                        {item.heading}
                                    </Typography>

                                    <Box display="flex" flexDirection="column" gap={2}>
                                        {item.bullets?.map((bullet: string, bi: number) => (
                                            <Box key={bi} display="flex" gap="12px" alignItems="flex-start">
                                                <Box flexShrink={0} mt="4px">
                                                    <DisplayImage
                                                        src={checkIcon}
                                                        alt=""
                                                        width={18}
                                                        height={18}
                                                        style={{width: 18, height: 18}}
                                                    />
                                                </Box>
                                                <Typography
                                                    className="font-regular-text"
                                                    sx={{fontSize: 16, color: '#000', lineHeight: '26px'}}
                                                >
                                                    {parse(bullet)}
                                                </Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>

                                {item.screenshot && (
                                    <Box
                                        sx={{
                                            flex: 1,
                                            display: 'flex',
                                            alignItems: 'flex-end',
                                            overflow: 'hidden',
                                            minHeight: 240
                                        }}
                                    >
                                        <DisplayImage
                                            src={item.screenshot}
                                            alt={item.heading}
                                            sizes="(max-width: 600px) 100vw, (max-width: 900px) 50vw, 33vw"
                                            style={{width: '100%', height: 'auto', display: 'block'}}
                                        />
                                    </Box>
                                )}
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </MUIContainer>
        </Box>
    );
};

export default memo(SolutionModel);
